/* =========================================
   CONTACT PAGE: STEPPER & BLOCK ANIMATIONS
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
    // Stepper Elements
    const track = document.getElementById('stepper-track');
    const btnNext1 = document.getElementById('btn-next-1');
    const btnNext2 = document.getElementById('btn-next-2');
    const btnBack1 = document.getElementById('btn-back-1');
    const btnBack2 = document.getElementById('btn-back-2');
    const btnSubmit = document.getElementById('btn-submit');
    
    const formTrack = document.getElementById('form-content-track');
    const successState = document.getElementById('success-state');

    // NEW: Variables for dynamic height
    const stepperWindow = document.querySelector('.stepper-window');
    const slides = document.querySelectorAll('.step-slide');

    let currentStep = 0; // 0, 1, or 2

    // NEW: Function to sync the height of the window to the active slide
    const syncStepperHeight = (stepIndex) => {
        if(slides[stepIndex]) {
            const targetHeight = slides[stepIndex].offsetHeight;
            stepperWindow.style.gridTemplateRows = `${targetHeight}px`;
        }
    };

    // NEW: Initialize height on load, and adjust on window resize
    setTimeout(() => syncStepperHeight(0), 100); 
    window.addEventListener('resize', () => syncStepperHeight(currentStep));

    // NEW: Initialize inert states on load to prevent keyboard tabbing into hidden slides
    slides.forEach((slide, index) => {
        if (index !== 0) slide.setAttribute('inert', '');
    });

    // =========================================
    // GSAP ABC Block Animations
    // =========================================
    // Block Initial Entry Setup
    gsap.set('.abc-block', { y: -200, opacity: 0, scale: 0.8, rotation: -15 });

    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const animateBlockIn = (blockSelector) => {
        gsap.to(blockSelector, {
            y: 0,
            opacity: 1,
            scale: 1,
            rotation: 0,
            duration: isReduced ? 0 : 1,
            ease: "bounce.out" // Gives that heavy wooden block physics!
        });
    };

    const animateBlockOut = (blockSelector) => {
        gsap.to(blockSelector, {
            y: -50,
            opacity: 0,
            scale: 0.8,
            rotation: 10,
            duration: isReduced ? 0 : 0.4,
            ease: "power2.in"
        });
    };

    // =========================================
    // Page Intro Waterfall & Scroll Animations
    // =========================================
    gsap.registerPlugin(ScrollTrigger);

    // Hide stepper initially for the waterfall reveal
    gsap.set('.stepper-window', { opacity: 0, y: 40 });

    const introTl = gsap.timeline({ delay: isReduced ? 0 : 0.3 }); // Wait a fraction for global headers to start
    
    // Float the window up smoothly
    introTl.to('.stepper-window', {
        opacity: 1, 
        y: 0, 
        duration: isReduced ? 0 : 0.8, 
        ease: 'power3.out'
    }).call(() => {
        // Drop Block A just as the window settles
        animateBlockIn('.block-a');
    }, null, isReduced ? 0 : "-=0.4");

    // Scroll Animation for Map & Contact Info Section
    gsap.fromTo('.contact-details > *', 
        { opacity: 0, x: -30 }, 
        {
            opacity: 1, 
            x: 0, 
            duration: isReduced ? 0 : 0.8, 
            stagger: isReduced ? 0 : 0.15, 
            ease: 'power3.out',
            scrollTrigger: { trigger: '.contact-grid', start: 'top 85%', once: true }
        }
    );

    gsap.fromTo('.map-card', 
        { opacity: 0, x: 30, scale: 0.95 }, 
        {
            opacity: 1, 
            x: 0, 
            scale: 1, 
            duration: isReduced ? 0 : 1, 
            ease: 'power2.out',
            scrollTrigger: { trigger: '.contact-grid', start: 'top 85%', once: true }
        }
    );

    // =========================================
    // Stepper Navigation Logic
    // =========================================
    const updateStepper = (newStep, direction) => {
        currentStep = newStep;
        
        // Slide the track
        track.style.transform = `translateX(-${currentStep * 33.333}%)`;

        // NEW: Dynamically adjust the height of the white card
        syncStepperHeight(currentStep);

        // Update inert state for accessibility to prevent tabbing into hidden slides
        slides.forEach((slide, index) => {
            if (index === currentStep) {
                slide.removeAttribute('inert');
            } else {
                slide.setAttribute('inert', '');
            }
        });

        // Coordinate Blocks
        if (currentStep === 1 && direction === 'forward') {
            animateBlockIn('.block-b'); // Step 2: Drop B
        } else if (currentStep === 2 && direction === 'forward') {
            animateBlockIn('.block-c'); // Step 3: Drop C
        } else if (currentStep === 0 && direction === 'backward') {
            animateBlockOut('.block-b'); // Back to 1: Remove B
        } else if (currentStep === 1 && direction === 'backward') {
            animateBlockOut('.block-c'); // Back to 2: Remove C
        }
        
        // Smooth scroll to top of form (ONLY on mobile so desktop users don't get a jarring jump!)
        if (window.innerWidth <= 768) {
            // Bulletproof scroll calculation: Section Top - Fixed Header Height - 10px breathing room
            const section = document.querySelector('.pyramid-container');
            const headerOffset = 65; 
            const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
            
            window.scrollTo({
                 top: sectionPosition - headerOffset,
                 behavior: 'smooth'
            });
        }
    };

    // =========================================
    // Step Validation Logic
    // =========================================
    const validateStep = (stepIndex) => {
        const currentSlide = document.querySelectorAll('.step-slide')[stepIndex];
        const inputs = currentSlide.querySelectorAll('input[required], textarea[required], select[required]');
        let isValid = true;
        let firstInvalidInput = null;

        // Clear all existing error messages in this step first
        currentSlide.querySelectorAll('.error-message').forEach(el => el.remove());

        inputs.forEach(input => {
            if (!input.value.trim() || !input.checkValidity()) {
                isValid = false;
                input.classList.add('input-error', 'shake-error');
                
                // Track the first failing input to focus it later
                if (!firstInvalidInput) {
                    firstInvalidInput = input;
                }

                // Inject inline error message immediately below the failing input
                input.insertAdjacentHTML('afterend', '<span class="error-message" role="alert">This field is required</span>');
                
                // Remove shake class after animation
                setTimeout(() => input.classList.remove('shake-error'), 300);
            } else {
                input.classList.remove('input-error');
            }
        });

        // Set focus to the first invalid input for immediate keyboard/screen reader access
        if (firstInvalidInput) {
            firstInvalidInput.focus();
        }

        syncStepperHeight(currentStep);
        return isValid;
    };

    // Warn users about unsaved changes if they try to leave
    let formHasUnsavedChanges = false;
    document.querySelectorAll('input, textarea, select').forEach(input => {
        input.addEventListener('input', () => {
            formHasUnsavedChanges = true;
        });
    });

    window.addEventListener('beforeunload', (e) => {
        if (formHasUnsavedChanges) {
            e.preventDefault();
            e.returnValue = ''; // Standard way to trigger the browser's native leave confirmation dialog
        }
    });

    // Clear error styling and messages instantly when user types
    document.querySelectorAll('.form-input, .form-textarea, .form-select, .form-input-checkbox').forEach(input => {
        const clearError = () => {
            let isValid = input.type === 'checkbox' ? input.checked : input.value.trim();
            if (input.classList.contains('input-error') && isValid) {
                input.classList.remove('input-error');
                const errorSpan = input.nextElementSibling;
                if (errorSpan && errorSpan.classList.contains('error-message')) {
                    errorSpan.remove();
                    syncStepperHeight(currentStep);
                }
            }
        };
        input.addEventListener('input', clearError);
        if (input.type === 'checkbox') {
            input.addEventListener('change', clearError);
        }
    });

    // Enter Key Trap to prevent premature submission
    document.querySelectorAll('.step-slide').forEach((slide, index) => {
        slide.querySelectorAll('input').forEach(input => {
            input.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    if (index === 0) btnNext1.click();
                    if (index === 1) btnNext2.click();
                    if (index === 2) btnSubmit.click();
                }
            });
        });
    });

    // Event Listeners for Nav (with Validation Gates)
    if(btnNext1) btnNext1.addEventListener('click', () => {
        if (validateStep(0)) updateStepper(1, 'forward');
    });
    if(btnNext2) btnNext2.addEventListener('click', () => {
        if (validateStep(1)) updateStepper(2, 'forward');
    });
    if(btnBack1) btnBack1.addEventListener('click', () => updateStepper(0, 'backward'));
    if(btnBack2) btnBack2.addEventListener('click', () => updateStepper(1, 'backward'));

    // Submit Animation (Agent & Keyboard Optimized)
    const bookingForm = document.getElementById('booking-form');
    if(bookingForm) {
        bookingForm.addEventListener('submit', (e) => {
            e.preventDefault(); // Prevent page reload from human or AI submission
            
            // Final validation check for ALL steps (safeguards against AI or keyboard bypasses)
            if (!validateStep(0) || !validateStep(1) || !validateStep(2)) {
                // Auto-slide back to the step that has the error
                if (!validateStep(0)) updateStepper(0, 'backward');
                else if (!validateStep(1)) updateStepper(1, 'backward');
                return; // Stop submission
            }
            // Validation passed. Proceed with submission sequence.
            formHasUnsavedChanges = false; // Prevent beforeunload warning since we are submitting

            // Add Loading State to the submit button
            btnSubmit.disabled = true;
            btnSubmit.textContent = 'Confirming...';
            
            // WebMCP / AI Agent Support: Only hand a receipt back if the AI actually invoked the submit
            if (e.agentInvoked && typeof e.respondWith === 'function') {
                e.respondWith("Success! The tour request has been received and the confirmation screen is displayed.");
            }
            
            // Artificial delay to simulate network request and show the "Confirming..." state
            setTimeout(() => {
                const lottiePlayer = document.getElementById('success-lottie');
                
                // 1. Start the Lottie instantly in the background so there is zero load lag
                lottiePlayer.seek('10%'); 
                lottiePlayer.play();
                
                setTimeout(() => {
                    lottiePlayer.pause();
                }, 3800);
                
                // 2. Measure target height and safely scroll user into view
                // Synchronously un-anchor the state to measure its true natural height without causing a visual repaint
                successState.style.position = 'relative';
                const successHeight = successState.scrollHeight;
                successState.style.position = 'absolute';
                
                if (window.innerWidth <= 768) {
                    const section = document.querySelector('.pyramid-container');
                    const headerOffset = 80; 
                    const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
                    
                    window.scrollTo({
                         top: sectionPosition - headerOffset,
                         behavior: 'smooth'
                    });
                }
                
                // 3. Crossfade the UI & Shrink the Window
                const tl = gsap.timeline();
                tl.to(formTrack, { opacity: 0, duration: 0.4, ease: "power2.inOut" })
                  .set(formTrack, { pointerEvents: 'none', display: 'none' })
                  .set(successState, { pointerEvents: 'all', y: 30 })
                  // Shrink the window smoothly using grid-template-rows
                  .to(stepperWindow, { gridTemplateRows: `${successHeight}px`, duration: 0.5, ease: "power3.inOut" }, "<")
                  .to(successState, { opacity: 1, y: 0, duration: 0.6, ease: "power3.out" }, "<0.2");
            }, 800);
        });
    }
});